export default function initDestinationScrollspy() {
  const nav = document.querySelector('[data-destination-scrollspy]');

  if (!nav) {
    return;
  }

  const links = Array.from(nav.querySelectorAll('.destination-nav__links a[href^="#"]'));
  const sections = links
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  if (!links.length || !sections.length) {
    return;
  }

  let frameId = null;

  const updateActiveLink = () => {
    frameId = null;
    const offset = nav.getBoundingClientRect().height + 120;
    let activeSection = sections[0];

    sections.forEach((section) => {
      if (section.getBoundingClientRect().top <= offset) {
        activeSection = section;
      }
    });

    links.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${activeSection.id}`;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const requestUpdate = () => {
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(updateActiveLink);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  updateActiveLink();
}
